// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { PRECIO_JUSTO_DICTIONARY_ROW_DATA } from './constants'

export function dictionaryRowData(rowData) {
  return {
    type: PRECIO_JUSTO_DICTIONARY_ROW_DATA,
    payload: rowData,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRECIO_JUSTO_DICTIONARY_ROW_DATA:
      return {
        ...state,
        dictionaryRowData: action.payload,
      }

    default:
      return state
  }
}
